export default "__VITE_ASSET__c8c0d107__"